module.exports = __webpack_public_path__ + "static/media/consumption.ebf96c0e.png";